import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBorderTopComponent } from "./med-icon-border-top.component";

@NgModule({
  declarations: [
    MedIconBorderTopComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBorderTopComponent,
  ],
})
export class MedIconBorderTopModule { }
